export default "__VITE_ASSET__BXI5l_WV__"